import { render } from "./DadosRecarga.vue?vue&type=template&id=2b7f57e0"
import script from "./DadosRecarga.vue?vue&type=script&lang=js"
export * from "./DadosRecarga.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__